import { Box, Stack, Typography } from "@mui/material"
import { OreveButton } from "components/button/OreveButton.tsx"
import { entitiesMockData } from "mock/datas/entities"
import { profilesMockData } from "mock/datas/profiles"
import { UserSchema } from "mock/schemas"
import { useAuth } from "services/auth/auth-service-hooks"

export const MockLoginPage = () => {
    const { setUser } = useAuth()

    const handleLogin = (profile: UserSchema) => {
        if (setUser) setUser(profile)
    }
    const entityName = (entity_id: string) => {
        const entity = entitiesMockData.find((e) => e.id === entity_id)
        return entity ? entity.entity_name : "Entité inconnue"
    }

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                mt: 10,
            }}
        >
            <Typography variant="display">Veuillez vous connecter</Typography>
            <Typography variant="bodySmall" color="error.main">
                Version de développement, données factices
            </Typography>
            <Stack direction="row" spacing={20} sx={{ mt: "30vh" }}>
                {profilesMockData.map((profile) => (
                    <Stack
                        key={profile.id}
                        direction={"column"}
                        spacing={2}
                        alignItems={"center"}
                    >
                        <Typography variant="title">
                            En tant que {profile.firstName} {profile.lastName},
                            gestionnaire {entityName(profile.entity_id)}
                        </Typography>
                        <OreveButton
                            variant="outlined"
                            color="primary"
                            value="Se connecter"
                            onClick={() => handleLogin(profile)}
                        />
                    </Stack>
                ))}
            </Stack>
        </Box>
    )
}
